import { render, staticRenderFns } from "./schoolDistrictSelect.vue?vue&type=template&id=68a956d0&scoped=true&"
import script from "./schoolDistrictSelect.vue?vue&type=script&lang=js&"
export * from "./schoolDistrictSelect.vue?vue&type=script&lang=js&"
import style0 from "./schoolDistrictSelect.vue?vue&type=style&index=0&id=68a956d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a956d0",
  null
  
)

export default component.exports